import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Component to handle route normalization and proper 404 handling
const RouteHandler = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useEffect(() => {
    // Handle trailing slashes - redirect to non-trailing slash version
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      const newPath = location.pathname.slice(0, -1);
      window.history.replaceState(null, '', newPath + location.search + location.hash);
    }
  }, [location]);

  return <>{children}</>;
};

export default RouteHandler;